import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { openWorkbookInDesktop } from '../../../actions/spaces/OpenWorkbookInDesktopAction';
import { hideLaunchEditOnMobile } from '../../../utils/MobileHelper';

export const OpenWorkbookInDesktopAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.OpenWorkbookInDesktop,
  translateName: Messages.openWorkbookInDesktop,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.connectedExperienceEnabled && !hideLaunchEditOnMobile();
  },
  isClickable: (_availableActions: {}) => {
    return FeatureFlags.connectedExperienceEnabled;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return openWorkbookInDesktop(targetItems[0]);
  }
};
